export default __webpack_public_path__ + "static/media/canvasAndFramedLargeCanvas.f3e4d73d.jpg";